
import React, { useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import SuccessfulModal from './SuccessfulModal';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";
import FormikControl from '../../../components/signUpForm/ReusableFormik/FormikControl';
import Loading from '../../../components/common/Loading';
import { CloseIcon } from '../../../components/common/IconComponents';

const AddMemberModal = ({ isOpen, onClose }) => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const dropDownOptions = [
        { key: "Select", value: "" },
        { key: "Admin", value: "Admin" },
        { key: "Analyst", value: "Analyst" },
    ];

    const initialValues = {
        firstname: "",
        lastname: "",
        email: "",
        permission: "",
    };

    const handleSuccessModalClose = () => {
        setIsSuccess(false);
        onClose();
    };

    // validation
    const validationSchema = Yup.object({
        firstname: Yup.string().required("Required"),
        lastname: Yup.string().required("Required"),
        email: Yup.string().email("Invalid email format").required("Required"),
        permission: Yup.string().required("Required"),
    });

    const params = useParams();
    const id = params.id;

    // Form submission
    const onSubmit = async (values, { resetForm }) => {
        setIsSubmitting(true);
        try {
            const response = await axios.post(
                "https://smartapp-lendbackend.onrender.com/api/admin/invite-teammember",
                { invitedBy: id, invitedUser: values }
            );
            console.log("API response", response.data);
            setIsSuccess(true);
            navigate("/successfulModal");
        } catch (error) {
            console.error("API error", error);
            alert(error.response.data);
        } finally {
            setIsSubmitting(false);
            resetForm();
        }
    };

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-pale-white opacity-4 flex items-center justify-center z-50">
                    {/* modal */}
                    <div className="w-auto sm:w-3/4 lg:max-w-2xl border border-gray bg-white p-6 rounded-md shadow-md">
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmit}
                        >
                            {(formik) => {
                                const isFormValid = formik.dirty && formik.isValid;
                                return (
                                    <Form className="">
                                        <div className="flex justify-between items-start">
                                            <h2 className="text-xl sm:text-2xl md:text-3xl font-medium mb-7">Add team member</h2>
                                            <CloseIcon onClick={onClose} />
                                        </div>

                                        <FormikControl
                                            control="input"
                                            label="First name (required)"
                                            type="text"
                                            placeholder="e.g. Oluwatofunmi"
                                            name="firstname"
                                        />

                                        <FormikControl
                                            control="input"
                                            label="Last name (required)"
                                            type="text"
                                            placeholder="e.g. Idowu"
                                            name="lastname"
                                        />

                                        <FormikControl
                                            control="input"
                                            label="Work email address (required)"
                                            type="email"
                                            placeholder="e.g. idowu.oluwatofunmi9@gmail.com"
                                            name="email"
                                        />

                                        <FormikControl
                                            control="select"
                                            label="Permission"
                                            name="permission"
                                            options={dropDownOptions}
                                        />

                                        <div className="flex items-center justify-between mt-6">
                                            <button
                                                type="submit"
                                                className={`${isFormValid
                                                    ? 'bg-enabled-btn text-white hover:bg-indigo-600 cursor-pointer'
                                                    : 'bg-disabled-btn text-disabled cursor-not-allowed'
                                                    } py-2 px-14 rounded`}
                                                disabled={!isFormValid || isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <Loading
                                                        type="spinningBubbles"
                                                        color="#FFF"
                                                        height={20}
                                                        width={20}
                                                    />
                                                ) : (
                                                    'Add team member'
                                                )}
                                            </button>
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            )}

            {isSuccess && (
                <SuccessfulModal onClose={handleSuccessModalClose} />
            )}
        </>
    );
};

AddMemberModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default AddMemberModal;


// import React, { useState } from 'react';
// import { useNavigate, useParams } from "react-router-dom";
// import PropTypes from 'prop-types';
// import SuccessfulModal from './SuccessfulModal';
// import { Formik, Form } from "formik";
// import * as Yup from "yup";
// import axios from "axios";
// import FormikControl from '../../../components/signUpForm/ReusableFormik/FormikControl';
// import Loading from '../../../components/common/Loading';
// import { CloseIcon } from '../../../components/common/IconComponents';

// const AddMemberModal = ({ isOpen, onClose }) => {
//     const [isSuccess, setIsSuccess] = useState(false);
//     const [isButtonClicked, setIsButtonClicked] = useState(false);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const navigate = useNavigate();

//     const dropDownOptions = [
//         { key: "Select", value: "" },
//         { key: "Admin", value: "Admin" },
//         { key: "Analyst", value: "Analyst" },
//     ];

//     const initialValues = {
//         firstname: "",
//         lastname: "",
//         email: "",
//         permission: "",
//     };

//     const handleSuccessModalClose = () => {
//         setIsSuccess(false);
//         setIsButtonClicked(false);
//         onClose();
//     };

//     // validation
//     const validationSchema = Yup.object({
//         firstname: Yup.string().required("Required"),
//         lastname: Yup.string().required("Required"),
//         email: Yup.string().email("Invalid email format").required("Required"),
//         permission: Yup.string().required("Required"),
//     });

//     const params = useParams();
//     const id = params.id;

//     // Form submission
//     const onSubmit = async (values, { resetForm }) => {
//         setIsButtonClicked(true);
//         setIsSubmitting(true);
//         try {
//             const response = await axios.post(
//                 "https://smartapp-lendbackend.onrender.com/api/admin/invite-teammember",
//                 { invitedBy: id, invitedUsers: teamMembers }
//             );
//             console.log("API response", response.data);
//             setIsSuccess(true);
//             navigate("/successfulModal");
//         } catch (error) {
//             console.error("API error", error);
//             alert(error.response.data);
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     return (
//         <>
//             {isOpen && (
//                 <div className="fixed inset-0 bg-pale-white opacity-4 flex items-center justify-center z-50">
//                     {/* modal */}
//                     <div className="w-auto sm:w-3/4 lg:max-w-2xl border border-gray bg-white p-6 rounded-md shadow-md">
//                         <Formik
//                             initialValues={initialValues}
//                             validationSchema={validationSchema}
//                             onSubmit={onSubmit}
//                         >
//                             {(formik) => {
//                                 const isFormValid = formik.dirty && formik.isValid;
//                                 return (
//                                     <Form className="">
//                                         <div className="flex justify-between items-start">
//                                             <h2 className="text-xl sm:text-2xl md:text-3xl font-medium mb-7">Add team member</h2>
//                                             <CloseIcon onClick={onClose} />
//                                         </div>

//                                         <FormikControl
//                                             control="input"
//                                             label="First name (required)"
//                                             type="text"
//                                             placeholder="e.g. Oluwatofunmi"
//                                             name="firstname"
//                                         />

//                                         <FormikControl
//                                             control="input"
//                                             label="Last name (required)"
//                                             type="text"
//                                             placeholder="e.g. Idowu"
//                                             name="lastname"
//                                         />

//                                         <FormikControl
//                                             control="input"
//                                             label="Work email address (required)"
//                                             type="email"
//                                             placeholder="e.g. idowu.oluwatofunmi9@gmail.com"
//                                             name="email"
//                                         />

//                                         <FormikControl
//                                             control="select"
//                                             label="Permission"
//                                             name="permission"
//                                             options={dropDownOptions}
//                                         />

//                                         {/* <div className="flex items-center justify-between mt-6">
//                                             <button
//                                                 type="submit"
//                                                 className={`${!formik.values.teamMembers
//                                                     ? "bg-disabled-btn text-disabled cursor-not-allowed"
//                                                     : "bg-enabled-btn text-white hover:bg-indigo-600"
//                                                     } py-2 px-14 rounded cursor-pointer `}
//                                                 disabled={!formik.values || isSubmitting}
//                                                 onClick={submitToAPI}
//                                             >
//                                             {isSubmitting ? (
//                                                 <Loading
//                                                     type="spinningBubbles"
//                                                     color="#FFF"
//                                                     height={20}
//                                                     width={20}
//                                                 />
//                                             ) : (
//                                                 "Add team member"
//                                             )}
//                                             </button>
//                                         </div> */}
//                                         <div className="flex items-center justify-between mt-6">
//                                             <button
//                                                 type="submit"
//                                                 className={`${isFormValid
//                                                         ? 'bg-enabled-btn text-white hover:bg-indigo-600 cursor-pointer'
//                                                         : 'bg-disabled-btn text-disabled cursor-not-allowed'
//                                                     } py-2 px-14 rounded`}
//                                                 disabled={!isFormValid || isSubmitting}
//                                             >
//                                                 {isSubmitting ? (
//                                                     <Loading
//                                                         type="spinningBubbles"
//                                                         color="#FFF"
//                                                         height={20}
//                                                         width={20}
//                                                     />
//                                                 ) : (
//                                                     'Add team member'
//                                                 )}
//                                             </button>
//                                         </div>
//                                     </Form>
//                                 );
//                             }}
//                         </Formik>
//                     </div>
//                 </div>
//             )}

//             {isSuccess && isButtonClicked && (
//                 <SuccessfulModal onClose={handleSuccessModalClose} />
//             )}
//         </>
//     );
// };

// AddMemberModal.propTypes = {
//     isOpen: PropTypes.bool.isRequired,
//     onClose: PropTypes.func.isRequired,
// };

// export default AddMemberModal;








// working without api call to add team members
// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import CustomButton from '../../../components/common/CustomButton';
// import SuccessfulModal from './SuccessfulModal';
// import ReusableInput from '../../../components/common/ReusableInput';
// import PermissionInput from '../../../components/common/PermissionInput';

// const options = [
//     { value: 'option1', label: 'Admin' },
//     { value: 'option2', label: 'Analyst' },
// ];

// const AddMemberModal = ({ isOpen, onClose }) => {
//     const [selectedOption, setSelectedOption] = useState(null);
//     const [isButtonEnabled, setIsButtonEnabled] = useState(false);
//     const [isSuccess, setIsSuccess] = useState(false);
//     const [isButtonClicked, setIsButtonClicked] = useState(false);
//     const [email, setEmail] = useState('');

//     const handleOptionChange = (option) => {
//         setSelectedOption(option);
//         setIsButtonEnabled(option !== null);
//     };

//     const handleAddMember = () => {
//         // Perform addition logic here and set isSuccess to true if successful
    
//         // Simulating a successful addition
//         setIsSuccess(true);
//         setIsButtonClicked(true);
//         setEmail('oluwatofunmiIdowu@gmail.com');
//         // setEmail('email');

//     };

//     const handleSuccessModalClose = () => {
//         setIsSuccess(false);
//         setIsButtonClicked(false);
//         onClose();
//     };

//     const handleAddMemberButtonClick = () => {
//         handleAddMember();
//         onClose();
//         setIsSuccess(true);
//     };

//     return (
//         <>
//             {isOpen && (
//                 <div className="fixed inset-0 bg-pale-white opacity-4 flex items-center justify-center z-50">
//                     {/* modal */}
//                     <div className="w-auto sm:w-3/4 lg:max-w-2xl border border-gray bg-white p-6 rounded-md shadow-md">
//                         <form>
//                             <h2 className="text-xl sm:text-2xl md:text-3xl font-medium mb-7">Add team member</h2>

//                             <ReusableInput
//                                 label="Email Address"
//                                 type="email"
//                                 placeholder="e.g. idowu.oluwatofunmi9@gmail.com"
//                                 value={email}
//                                 onChange={(event) => setEmail(event.target.value)}
//                             />

//                             <PermissionInput
//                                 label="Permission"
//                                 options={options}
//                                 value={selectedOption}
//                                 onChange={handleOptionChange}
//                             />

//                             <div className="flex justify-start mb-5 mt-12">
//                                 <CustomButton
//                                     className={
//                                         isButtonEnabled && !isButtonClicked
//                                             ? 'bg-enabled-btn text-white'
//                                             : 'bg-disabled-btn text-disabled cursor-not-allowed'
//                                     }
//                                     onClick={handleAddMemberButtonClick}
//                                     disabled={!isButtonEnabled || isButtonClicked}
//                                 >
//                                     Add team member
//                                 </CustomButton>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}

//             {isSuccess && isButtonClicked && (
//                 <SuccessfulModal email={email} onClose={handleSuccessModalClose} />
//             )}
//         </>
//     );
// };

// AddMemberModal.propTypes = {
//     isOpen: PropTypes.bool.isRequired,
//     onClose: PropTypes.func.isRequired,
// };

// export default AddMemberModal;











// first logic. left for reference purposes
// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import CustomButton from '../../../components/common/CustomButton';
// import SuccessfulModal from './SuccessfulModal';
// import ReusableInput from '../../../components/common/ReusableInput';
// import PermissionInput from '../../../components/common/PermissionInput';

// const options = [
//     { value: 'option1', label: 'Admin' },
//     { value: 'option2', label: 'Analyst' },
// ];

// const AddMemberModal = ({ isOpen, onClose }) => {
//     const [selectedOption, setSelectedOption] = useState(null);
//     const [isButtonEnabled, setIsButtonEnabled] = useState(false);
//     const [isSuccess, setIsSuccess] = useState(false);
//     const [isButtonClicked, setIsButtonClicked] = useState(false);
//     const [email, setEmail] = useState('');


//     const handleOptionChange = (option) => {
//         setSelectedOption(option);
//         setIsButtonEnabled(option !== null);
//     };

//     const handleAddMember = () => {
//         // Perform addition logic here and set isSuccess to true if successful

//         // Simulating a successful addition
//         setIsSuccess(true);
//         setIsButtonClicked(true);
//         setEmail('oluwatofunmiIdowu@gmail.com');
//         // setEmail('email');
//     };

//     const handleSuccessModalClose = () => {
//         setIsSuccess(false);
//         setIsButtonClicked(false);
//         onClose();
//     };

//     const handleAddMemberButtonClick = () => {
//         handleAddMember();
//         onClose();
//         setIsSuccess(true);
//     };

//     return (
//         <>
//             {isOpen && (
//                 <div className="fixed inset-0 bg-pale-white opacity-4 flex items-center justify-center z-50">
//                     {/* modal */}
//                     <div className="w-auto sm:w-3/4 lg:max-w-2xl border border-gray bg-white p-6 rounded-md shadow-md">
//                         <form>
//                             <h2 className="text-xl sm:text-2xl md:text-3xl font-medium mb-7">Add team member</h2>

//                             <ReusableInput
//                                 label="Email Address"
//                                 type="email"
//                                 placeholder="e.g. idowu.oluwatofunmi9@gmail.com"
//                                 value={email}
//                                 onChange={(event) => setEmail(event.target.value)}
//                             />

//                             <PermissionInput
//                                 label="Permission"
//                                 options={options}
//                                 value={selectedOption}
//                                 onChange={handleOptionChange}
//                             />

//                             <div className="flex justify-start mb-5 mt-12">
//                                 <CustomButton
//                                     className={
//                                         isButtonEnabled && !isButtonClicked
//                                             ? 'bg-enabled-btn text-white'
//                                             : 'bg-disabled-btn text-disabled cursor-not-allowed'
//                                     }
//                                     onClick={handleAddMemberButtonClick}
//                                     disabled={!isButtonEnabled || isButtonClicked}
//                                 >
//                                     Add team member
//                                 </CustomButton>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             )}

//             {isSuccess && isButtonClicked && (
//                 <SuccessfulModal email={email} onClose={handleSuccessModalClose} />
//             )}
//         </>
//     );
// };

// AddMemberModal.propTypes = {
//     isOpen: PropTypes.bool.isRequired,
//     onClose: PropTypes.func.isRequired,
// };

// export default AddMemberModal;
